exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".tree-breadcrumb{margin-bottom:5px}.tree-mask{position:fixed;top:0;left:0;width:100%;background-color:#edf2fb;z-index:999}.tree-overflow-hidden{overflow:hidden!important}.tree-content{overflow-y:auto;-webkit-overflow-scrolling:touch}.tree-search-list{overflow:auto}.tree-search-nodata{position:absolute;top:20%;left:50%;color:#c4c9d9;transform:translateX(-50%)}.tree-search-nodata>div{padding:5px 0}.tree-placeholder{color:#c4c9d9}.tree-svg{vertical-align:bottom;width:21px;height:21px}.tree-svg-color-primary{fill:#3b7bff}.tree-svg-color-default{fill:#c4c9d9}.tree-color-primary{color:#3b7bff}.tree-color-disabled{color:#c4c9d9}.tree-button-action{height:50px;background-color:#fff;padding:7px 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-rewriter.js?id=data-v-1c9a388f!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/tg-tree.vue
// module id = 232
// module chunks = 0